module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "row"
  }, _vm._l((_vm.sellpoints), function(sp) {
    return _c('li', {
      key: sp.business_id,
      staticClass: "col-md-6"
    }, [_c('article', [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": "static/assets/images/new-ar-img-1.jpg",
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sp-business-card"
    }, [_c('p', [_vm._v(_vm._s(sp.business_name))]), _vm._v(" "), _c('p', [_vm._v("Block 1B 2-face street AddisA Laos")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-small btn-round",
      attrs: {
        "href": 'points?pg=' + sp.business_url_name
      }
    }, [_vm._v("View my sellpoint")])])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6630e731"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sellpoint/SellpointList.vue
// module id = 286
// module chunks = 0